<template>
  <v-dialog v-model="dialog" width="1000">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="router-link-exact-active " text v-bind="attrs" v-on="on">
        Terms and Conditions
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <img :src="require('@/assets/terms/ATRC Platform - Website TCs-01.png')" width="100%" />
        <img :src="require('@/assets/terms/ATRC Platform - Website TCs-02.png')" width="100%" />
        <img :src="require('@/assets/terms/ATRC Platform - Website TCs-03.png')" width="100%" />
        <img :src="require('@/assets/terms/ATRC Platform - Website TCs-04.png')" width="100%" />
        <img :src="require('@/assets/terms/ATRC Platform - Website TCs-05.png')" width="100%" />
        <img :src="require('@/assets/terms/ATRC Platform - Website TCs-06.png')" width="100%" />
        <img :src="require('@/assets/terms/ATRC Platform - Website TCs-07.png')" width="100%" />
        <img :src="require('@/assets/terms/ATRC Platform - Website TCs-08.png')" width="100%" />
        <img :src="require('@/assets/terms/ATRC Platform - Website TCs-09.png')" width="100%" />
        <img :src="require('@/assets/terms/ATRC Platform - Website TCs-10.png')" width="100%" />
        <img :src="require('@/assets/terms/ATRC Platform - Website TCs-11.png')" width="100%" />
        <img :src="require('@/assets/terms/ATRC Platform - Website TCs-12.png')" width="100%" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TermsAndConditionsModal',
  data: () => ({
    dialog: false,
  }),
};
</script>
